import { faHeadset, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {Fragment, useState} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import cx from 'classnames';

function Chat(){
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openFilterModal = () => {
        setIsModalOpen(true);
      };
    const closeFilterModal = () => {
        setIsModalOpen(false);
	};
    return(
        <Fragment>
            <div class="ui-theme-settings">
                <div className={cx("iframe-container", {'hide': !isModalOpen})}>
                    <div className='container-header'>
                        Ozonetel
                        <button aria-label="Close" className='btn-close' onClick={(e) => closeFilterModal(e)}>
                        
                        </button>
                    </div>
                    <div className='container-body'>
				        <iframe allow="camera *; geolocation *; microphone *; autoplay *; display-capture *" id="lg-ctc-iframe" height="100%" width="100%" src="https://in-ccaas.ozonetel.com/toolbar_widget/index.html#login"/>
                    </div>
				</div>
                <button onClick={(e) => openFilterModal(e)} className={cx("btn-open-options btn btn-warning", {'hide': isModalOpen})} type="button" id="TooltipDemo">
                    <FontAwesomeIcon icon={faHeadset} />
                </button>
            </div>
        </Fragment>
    )
}

export default Chat;
